import { View, Text, TouchableOpacityComponent } from "react-native";
import React from "react";
import { danger, gray, primary, success, white } from "../../colors";
import VideoTutorialIcon from "../../assets/svg/VideoTutorialIcon";
import MyText from "../custom/MyText";
import translate from "../../functions/translate";
import { TouchableOpacity } from "react-native";
import LikeIcon from "../../assets/svg/LikeIcon";
import RenderHtml from "react-native-render-html";
import { Toast } from "react-native-toast-message/lib/src/Toast";
import { useSelector } from "react-redux";
import likeTutorial from "../../api/tutorial/likeTutorial";
import unlikeTutorial from "../../api/tutorial/unlikeTutorial";
import { Video } from "expo-av";
import MyVideo from "../MyVideo";

export default function TutorialBody({
  body,
  videoUrl,
  id,
  liked,
  setChange,
  change,
}) {
  const main = useSelector((store) => store.main);
  const source = {
    html: body,
  };
  const likeThisTutorial = () => {
    if (main.token === null) {
      Toast.show({
        type: "error",
        text1: translate("you are not logged in"),
      });
    } else {
      likeTutorial(id)
        .then(({ data }) => {
          setChange(!change);
        })
        .catch((err) => {});
    }
  };
  const unlikeThisTutorial = () => {
    if (main.token === null) {
      Toast.show({
        type: "error",
        text1: translate("you are not logged in"),
      });
    } else {
      unlikeTutorial(id)
        .then(({ data }) => {
          setChange(!change);
        })
        .catch((err) => {});
    }
  };

  return (
    <View style={{ width: "100%", alignItems: "center" }}>
      <View
        style={{
          width: "94%",
          borderWidth: 1,
          borderColor: primary,
          paddingTop: 50,
          paddingBottom: 20,
          paddingHorizontal: 10,
          borderRadius: 10,
        }}
      >
        <RenderHtml contentWidth={300} source={source} />
        {videoUrl !== null && videoUrl !== "" && (
          <View style={{ width: "100%", alignItems: "center", marginTop: 10 }}>
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                width: "100%",
              }}
            >
              <View
                style={{ marginHorizontal: 10, transform: [{ scale: 1.3 }] }}
              >
                <VideoTutorialIcon color={primary} />
              </View>
              <MyText style={{ color: gray }}>
                {translate("tutorial video")}
              </MyText>
            </View>
            <MyVideo url={videoUrl} />
          </View>
        )}
        <View
          style={{ flexDirection: "row", alignItems: "center", marginTop: 10 }}
        >
          <MyText style={{ fontSize: 12 }}>
            {translate("what is your feedback ?")}
          </MyText>
          <TouchableOpacity
            onPress={likeThisTutorial}
            style={{
              borderRadius: 10,
              borderColor: success,
              backgroundColor: liked === "like" ? success : white,
              borderWidth: 1,
              padding: 2,
              flexDirection: "row",
              alignItems: "center",
              marginHorizontal: 5,
            }}
          >
            <MyText
              style={{ fontSize: 10, color: liked === "like" ? white : gray }}
            >
              {translate("i liked it")}
            </MyText>
            <View>
              <LikeIcon />
            </View>
          </TouchableOpacity>
          <TouchableOpacity
            onPress={unlikeThisTutorial}
            style={{
              borderRadius: 10,
              borderColor: danger,
              backgroundColor: liked === "unLike" ? danger : white,
              borderWidth: 1,
              padding: 2,
              flexDirection: "row",
              alignItems: "center",
              marginHorizontal: 5,
            }}
          >
            <MyText
              style={{ fontSize: 10, color: liked === "unLike" ? white : gray }}
            >
              {translate("i didn't liked it")}
            </MyText>
            <View style={{ transform: [{ rotate: "180deg" }] }}>
              <LikeIcon />
            </View>
          </TouchableOpacity>
        </View>
      </View>
    </View>
  );
}
